const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 4);

exports.countryDefinition = {
  country: 'Philippines',
  code: 'PH',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'City/Municipality' },
    stateCode: { label: 'Province', width: 0.5 },
    zipCode: {
      label: 'Zip Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', SPACE, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city'],
    ['zipCode', 'stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(4)),
      error: 'Must be 4 characters, 1234'
    }
  ]
};
